export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img7-9d7e2e575099a9e9cdd94e76bb2a712c.jpg";